// export const baseUrl = 'https://wthedu.51suiyixue.com/youshiyouku'
// export const baseUrl = 'http://192.168.0.49:8091/'
export const baseUrl = 'https://wthedu.51suiyixue.com/youshiyouku'
// export const baseUrl = 'https://wthedu.51suiyixue.com/youshiyouku/'
// export const baseUrl = 'http://192.168.1.25:8091/'
//